import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {getJwtToken} from '../services/auth.service';

export default function GuestRoute() {
    // Recheck the stored session on browser and mobile history navigation.
    useLocation();

    return getJwtToken().token ? <Navigate to="/home" replace /> : <Outlet />;
}
